import React from 'react'
import { Button, ButtonProps } from '@mui/material'

import Link, { LinkProps } from './index'
import { useMixpanelCTAClickTracking } from '../../utils/mixpanel'
import useTidyLink from '../../hooks/useTidyLink'
import { MixpanelTracking } from '../../types/mixpanel'

type Props = Omit<LinkProps, 'variant'> &
  Omit<ButtonProps, 'component' | 'href'> & {
    to?: string
    href?: string
    mixpanelTracking?: MixpanelTracking
  }

const LinkButton: React.FC<Props> = (props) => {
  const handleMpCTAClickTracking = useMixpanelCTAClickTracking()
  const tidyTheLink = useTidyLink()

  return (
    // @ts-ignore
    <Button
      component={Link}
      {...props}
      onAuxClick={(e: any) => {
        if (props.onClick) {
          props.onClick(e)
        }

        handleMpCTAClickTracking(
          e.currentTarget.textContent,
          tidyTheLink(props.to ?? props.href),
          props.mixpanelTracking ?? null
        )
      }}
      onClick={(e: any) => {
        if (props.onClick) {
          props.onClick(e)
        }

        handleMpCTAClickTracking(
          e.currentTarget.textContent,
          tidyTheLink(props.to ?? props.href),
          props.mixpanelTracking ?? null
        )
      }}
    />
  )
}

export default LinkButton
